<!-- Copyright (C) 2017, 2018 DecElite LLC - All Rights Reserved. May not be distributed or copied. -->
<template>
  <v-flex
    xs12
    sm10
    offset-sm1
    md8
    offset-md2
    xl6
    offset-xl3
    class = "mb-4">
    <v-breadcrumbs
      v-if="$route.name === 'BlogPost'"
      divider="/"
      :items="crumbs" />
    <v-card
      raised
      v-show="!error">
      <v-img
        height = "200px"
        :src = "image"/>
      <v-card-title>
        <div>
          <div class="display-2 font-weight-light">
            <router-link :to = "meta.url">
              {{ title }}
            </router-link>
          </div>
          <div class="grey--text">{{ date }}</div>
        </div>
      </v-card-title>
      <v-card-text
        class="dc__blog_post"
        v-if="!loading"
        v-html="doc"/>
      <v-card-text v-if="loading">
        <v-progress-circular
          indeterminate
          size="120" />
      </v-card-text>
    </v-card>
    <v-card v-if="error & !loading">
      <v-responsive
        height = "200px"
        class = "warning"/>
      <v-card-title>
        <div>
          <div class="bluegrey--text darken-2 display-3">No Such Post</div>
          <div class="grey--text">... ... ...</div>
        </div>
      </v-card-title>
      <v-card-text>
        <strong>We could not find that blog post</strong>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
import * as VBreadcrumbs from 'vuetify/es5/components/VBreadcrumbs'
import * as VGrid from 'vuetify/es5/components/VGrid'
import * as VCard from 'vuetify/es5/components/VCard'
import VProgressCircular from 'vuetify/es5/components/VProgressCircular'
import VImg from 'vuetify/es5/components/VImg'
import VResponsive from 'vuetify/es5/components/VResponsive'
import { postMap } from '@/docs/blog.val.js'
import { setMeta } from '@/metaUtil'

export default {
  props: {
    id: {
      type:    String,
      default: '',
    },
  },
  data () {
    return {
      shortName: '',
      error:     false,
      loading:   true,
      doc:       {},
    }
  },
  methods: {
    mount () {
      let file = postMap[this.id].file
      import('@/docs/' + file + '.md')
        .then(doc => {
          this.doc = doc.default
          this.loading = false
          if (this.$route.path !== '/blog' &&
              this.$route.path !== '/blog/') {
            setMeta({
              title:       this.meta.title,
              image:       this.image,
              description: this.meta.subtitle,
              type:        'article',
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.error = true
          throw err
        })
    },
  },
  computed: {
    meta () {
      return postMap[this.id]
    },
    image () {
      return require('@/docs/blog/header_images/' + (this.meta.image || 'dice.jpg'))
    },
    title () {
      return (this.meta.title || 'Loading...')
    },
    date () {
      return new Date(this.meta.date)
        .toLocaleDateString(undefined, { timeZone: 'UTC' })
    },
    crumbs () {
      return [
        { exact: true, text: 'Blog', to: '/blog' },
        { text: this.title },
      ]
    },
  },
  created () {
    this.mount()
  },
  watchers: {
    id: () => {
      this.mount()
    },
  },
  components: {
    ...VBreadcrumbs,
    ...VGrid,
    ...VCard,
    VProgressCircular,
    VImg,
    VResponsive,
  },
}
</script>
<style>
  .dc__blog_post.v-card__text ul {
    margin-left: 16px;
    margin-bottom: 16px;
  }
  .dc__blog_post.v-card__text img {
    max-width: 100%;
  }
  .dc__blog_post.v-card__text table {
    border-collapse: collapse;
    display: inline-table;
  }

  .dc__blog_post.v-card__text thead {
    color: white;
    background: #888;
    font-size: larger;
  }

  .dc__blog_post.v-card__text table tr:nth-of-type(even) {
    background: #ddd;
  }

  .dc__blog_post.v-card__text table tr:hover {
    background: #aaa;
  }

  .dc__blog_post.v-card__text table th,
  .dc__blog_post.v-card__text table td {
    padding: 3px;
    border: 1px solid #888;
  }

  .dc__blog_post.v-card__text h2 {
    font-size: 32px !important;
    font-weight: 100;
  }
  .dc__blog_post.v-card__text h3 {
    font-size: 28px !important;
    font-weight: 100;
  }
  .dc__blog_post.v-card__text h4 {
    font-size: 24px !important;
    font-weight: 100;
  }
</style>
